import React, { useState } from "react";
import { Accordion, Divider } from "../../../components";
import { useTranslate } from "../../../features/translation/hooks/use-translation";
import {
  FormCheckboxGroup,
  FormRadioGroup,
  FormTextarea,
  FormTextInput,
} from "../../../features/auto-form";
import ACCESSIBILITY_OPTIONS from "../config/data/ancillaries/accessibility-options.json";
import DIETARY_REQUIREMENT_OPTIONS from "../config/data/ancillaries/dietary-requirements-options.json";
import ANCILLARIES_SPECIAL_LUGGAGE_OPTIONS from "../config/data/ancillaries/special-luggage.json";
import ANCILLARIES_STANDARD_LUGGAGE_OPTIONS from "../config/data/ancillaries/standard-luggage.json";
import ANCILLARIES_FLIGHT_MEAL_OPTIONS from "../config/data/ancillaries/flight-meal.json";
import ANCILLARIES_TRANSFER_OPTIONS from "../config/data/ancillaries/transfer.json";
import ANCILLARIES_SPORT_FACILITIES_OPTIONS from "../config/data/ancillaries/sport-facilities.json";
import ANCILLAIRES_RENTAL_OPTIONS from "../config/data/ancillaries/accommodation-rental-options.json";
//import ANCILLAIRES_SERVICE_OPTIONS from "../config/data/ancillaries/accommodation-service-options.json";


/*

    { "label": "Vegan options", "value": "vegan" },
    { "label": "Vegetarian options", "value": "vegetarian" },
    { "label": "Gluten free", "value": "glutenFree" },
    { "label": "Lactose free", "value": "lactoseFree" },
    { "label": "Kosher", "value": "kosher" }   
*/
const AncillarySection = ({
  id,
  label,
  name,
  icon,
  optionsGroups,
  textInputs,
  textAreas,
}) => {
  const { t } = useTranslate();

  const [selected, setSelected] = useState([]);

  const handleChange = (e) => {
    const { id, name, type, value } = e.target;
    const item = id || name;
    if (type === "checkbox") {
      setSelected((prev) =>
        prev.includes(item) ? prev.filter((s) => s !== item) : [...prev, item]
      );
    } else {
      if (!value && selected.includes(item)) {
        setSelected(selected.filter((s) => s !== item));
      } else if (value && !selected.includes(item)) {
        setSelected([...selected, item]);
      }
    }
  };

  return (
    <div className="row">
      <div className="col col-12">
        <Accordion
          label={label}
          name={name}
          icon={icon}
          className={selected.length > 0 ? "selected" : ""}
          notification={selected.length > 0 ? `+${selected.length}` : ""}
        >
          <div className="container">
            <div className="row">
              <div className="col col-12">
                <div
                  className="text base"
                  dangerouslySetInnerHTML={{
                    __html: t(`form.ancillaries.${id}.description`),
                  }}
                />
              </div>
            </div>

            {optionsGroups?.map((group, index) => (
              <div className="row" key={index}>
                <div className="col col-12">

                {group.type === "radio" ? (
                  <FormRadioGroup
                    className="horizontal"
                    name={group.name}
                    languagesection={group.languageSection}
                    label={group.label}
                    options={group.options}
                    onChange={handleChange}
                  />
                ) : (
                  <FormCheckboxGroup
                    className="horizontal"
                    name={group.name}
                    languagesection={group.languageSection}
                    label={group.label}
                    options={group.options}
                    onChange={handleChange}
                  />
                )}                
                </div>
              </div>
            ))}

            {textInputs?.map((input, index) => (
              <div className="row" key={`input-${index}`}>
                <div className="col col-12 col-md-4">
                  <FormTextInput
                    name={input.name}
                    label={input.label}
                    placeholder={input.placeholder}
                    languagesection={input.languageSection}
                    onChange={handleChange}
                  />
                </div>
              </div>
            ))}

            {textAreas?.map((area, index) => (
              <div className="row" key={`textarea-${index}`}>
                <div className="col col-12 col-md-6">
                  <FormTextarea
                    name={area.name}
                    label={area.label}
                    placeholder={area.placeholder}
                    languagesection={area.languageSection}
                    onChange={handleChange}
                  />
                </div>
              </div>
            ))}
          </div>
        </Accordion>
      </div>
    </div>
  );
};

const Ancillaries = () => {
  const { t } = useTranslate();

  return (
    <div className="container">
      <div className="row">
        <div className="col col-12">
          <Divider
            className="horizontal thin primary text-title "
            label={t("form.ancillaries.title")}
          />
        </div>
      </div>
      <div
        className="row"
        style={{
          paddingTop: "var(--space-4)",
          paddingBottom: "var(--space-8)",
        }}
      >
        <div className="col col-12">
          <div
            className="text base"
            style={{ textAlign: "center" }}
            dangerouslySetInnerHTML={{
              __html: t("form.ancillaries.description"),
            }}
          />
        </div>
      </div>
      <div className="row">
        <div className="col col-12">
          <div className="container">
            <AncillarySection
              id="luggageFlightMeal"
              label={t("form.ancillaries.luggageFlightMeal.label")}
              name="request.extra.flight"
              icon="aircraft"
              optionsGroups={[
                {
                  name: "request.extra.flight.luggage",
                  label: "Luggage (optional)",
                  languageSection:
                    "form.ancillaries.luggageFlightMeal.standardLuggage",
                  options: ANCILLARIES_STANDARD_LUGGAGE_OPTIONS,
                },
                {
                  name: "request.extra.flight.flightMeal",
                  label: "Flight meal (optional)",
                  languageSection:
                    "form.ancillaries.luggageFlightMeal.flightMeal",
                  options: ANCILLARIES_FLIGHT_MEAL_OPTIONS,
                  type: "radio" 
                },
              ]}
            />
            <AncillarySection
              id="specialLuggage"
              label={t("form.ancillaries.specialLuggage.label")}
              name="extra.specialLuggage"
              icon="luggage-plus"
              optionsGroups={[
                {
                  name: "request.extra.flight.specialLuggage.options",
                  languageSection:
                    "form.ancillaries.specialLuggage.specialLuggage",
                  options: ANCILLARIES_SPECIAL_LUGGAGE_OPTIONS,
                },
              ]}
              textInputs={[
                {
                  name: "request.extra.flight.specialLuggage.other",
                  languageSection:
                    "form.ancillaries.specialLuggage.specialLuggage.options.other",
                },
              ]}
            />
            <AncillarySection
              id="transfer"
              label={t("form.ancillaries.transfer.label")}
              name="extra.transfer"
              icon="transfer"
              optionsGroups={[
                {
                  name: "request.ancillaries.transfer",
                  languageSection: "form.ancillaries.transfer.transfer",
                  options: ANCILLARIES_TRANSFER_OPTIONS,
                },
              ]}
            />
                      <AncillarySection
              id="facilities"
              label={t("form.ancillaries.facilities.label")}
              name="request.extra.accommodation.facilities"
              icon="entertainment"
              optionsGroups={[
                {
                  name: "request.extra.accommodation.facilities.rent",
                  label: "Rental facilities",
                  languageSection: "form.ancillaries.facilities.rental",
                  options: ANCILLAIRES_RENTAL_OPTIONS,
                }
                /*,
                {
                  name: "request.extra.accommodation.facilities.services",
                  label: "Services",
                  languageSection: "form.ancillaries.facilities.service",
                  options: ANCILLAIRES_SERVICE_OPTIONS,
                },*/
              ]}
            />

            <AncillarySection
              id="sportFacilities"
              label={t("form.ancillaries.sportFacilities.label")}
              name="request.extra.accommodation.sportFacilities"
              icon="football"
              optionsGroups={[
                {
                  name: "request.extra.accommodation.sportFacilities",
                  label: "Sport facilities",
                  languageSection:
                    "form.ancillaries.sportFacilities.sportFacilities",
                  options: ANCILLARIES_SPORT_FACILITIES_OPTIONS,
                },
              ]}
            />
            <AncillarySection
              id="dietaryRequirements"
              label={t("form.ancillaries.dietaryRequirements.label")}
              name="request.extra.accommodation.dietaryRequirements"
              icon="cutlery-tray"
              optionsGroups={[
                {
                  name: "request.extra.accommodation.dietaryRequirements.options",
                  label: "Dietary requirements",
                  languageSection:
                    "form.ancillaries.dietaryRequirements.dietaryRequirements",
                  options: DIETARY_REQUIREMENT_OPTIONS,
                },
              ]}
              textAreas={[
                {
                  name: "extra.accommodation.dietaryRequirements.comment",
                  languageSection:
                    "form.ancillaries.dietaryRequirements.dietaryRequirements.options.other",
                },
              ]}
            />
            <AncillarySection
            id="accessibility"
            label={t("form.ancillaries.accessibility.label")}
            name="extra.accommodation.accessibility"
            icon="accessibility"
            optionsGroups={[
              {
                name: "request.extra.accommodation.accessibility.options",
                label: "Accessibility",
                languageSection:
                  "form.ancillaries.accessibility.accessibility",
                options: ACCESSIBILITY_OPTIONS,
              },
            ]}
            textAreas={[
              {
                name: "extra.accommodation.accessibility.comment",
                languageSection:
                  "form.ancillaries.accessibility.accessibility.options.other",
              },
            ]}
          />

          </div>
        </div>
      </div>
    </div>
  );
};

export default Ancillaries;
